import { create } from "zustand";
import { CompanyStoreProps } from "./interface/company.interface";
import {
  createMappingCompany,
  deleteMappingCompany,
  getAllArea,
  getAllCompanyGroup,
  getAreaByCompanyId,
  getCompanyAreaDetail,
  getFilterAdminUsrManagement,
  getUnAssignRoleInCompany,
  searchMappingCompany,
  updateMappingCompany,
} from "src/services/company.service";
import { CreateMappingCompanyDto, UpdateMappingCompanyDto } from "src/entity/company/company-response.entity";
import { FilterSearchCompanyMap } from "src/entity/company/company-mapping.entity";

export const companyStore = create<CompanyStoreProps>((set) => ({
  loadingCompanyGroup: false,
  loadingArea: false,
  loadingManageCompanyMap: false,
  loadingSearch: false,
  loadingGetUnAssign: false,
  loadingGetFilterCompany: false,
  dataCompanyGroup: [],
  dataArea: [],
  dataCompanyAreaDetails: [],
  dataFilterCompany: [],
  dataMapCompany: [],
  dataUnAssignRole: [],
  error: null,
  getAllCompanyGroup: async () => {
    set(() => ({ loadingCompanyGroup: true }));
    try {
      const res = await getAllCompanyGroup();
      set(() => ({ loadingCompanyGroup: false, dataCompanyGroup: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingCompanyGroup: false, error: err?.message, dataCompanyGroup: [] }));
    }
  },
  getUnAssignRoleInCompany: async () => {
    set(() => ({ loadingGetUnAssign: true }));
    try {
      const res = await getUnAssignRoleInCompany();
      set(() => ({ loadingGetUnAssign: false, dataUnAssignRole: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingGetUnAssign: false }));
    }
  },
  getFilterAdminUsrManagement: async () => {
    set(() => ({ loadingGetFilterCompany: true }));
    try {
      const res = await getFilterAdminUsrManagement();
      set(() => ({ loadingGetFilterCompany: false, dataFilterCompany: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingGetFilterCompany: false, dataFilterCompany: [] }));
    }
  },
  getAllArea: async () => {
    set(() => ({ loadingArea: true }));
    try {
      const res = await getAllArea();
      set(() => ({ loadingArea: false, dataArea: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingArea: false, error: err?.message, dataArea: [] }));
    }
  },
  getAreaByCompanyId: async (companyId: string) => {
    set(() => ({ loadingArea: true }));
    try {
      const res = await getAreaByCompanyId(companyId);
      set(() => ({ loadingArea: false, dataArea: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingArea: false, error: err?.message, dataArea: [] }));
    }
  },
  getCompanyAreaDetail: async () => {
    set(() => ({ loadingArea: true }));
    try {
      const res = await getCompanyAreaDetail();
      set(() => ({ dataCompanyAreaDetails: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ error: err?.message, dataCompanyAreaDetails: [] }));
    }
  },
  searchMappingCompany: async (filter: FilterSearchCompanyMap) => {
    set(() => ({ loadingSearch: true }));
    try {
      const res = await searchMappingCompany(filter);
      set(() => ({ loadingSearch: false, dataMapCompany: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loadingSearch: false, error: err?.message, dataMapCompany: [] }));
    }
  },
  createCompanyMap: async (data: CreateMappingCompanyDto) => {
    set(() => ({ loadingManageCompanyMap: true }));
    try {
      const response = await createMappingCompany(data);
      // console.log("response create map company :: ", response);
      set(() => ({ loadingManageCompanyMap: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageCompanyMap: false, error: message }));
      return message;
    }
  },
  updateMappingCompany: async (data: UpdateMappingCompanyDto) => {
    set(() => ({ loadingManageCompanyMap: true }));
    try {
      const response = await updateMappingCompany(data);
      // console.log("response update map company :: ", response);
      set(() => ({ loadingManageCompanyMap: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageCompanyMap: false, error: message }));
      return message;
    }
  },
  deleteMappingCompany: async (_id: string) => {
    set(() => ({ loadingManageCompanyMap: true }));
    try {
      const response = await deleteMappingCompany(_id);
      // console.log("response delete map company :: ", response);
      set(() => ({ loadingManageCompanyMap: false }));
    } catch (err: any) {
      set(() => ({ loadingManageCompanyMap: false, error: err?.message }));
    }
  },
  clearErrorSettingCompany: () => {
    set(() => ({ error: null }));
  },
  setLoadingManageCompanyMap: (value: boolean) => {
    set(() => ({ loadingManageCompanyMap: value }));
  },
}));
